// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1RrrL","row":"ProcedureTreatmentSummary_row__6WJtv"};